const checkBoxMarkShapeClassName =
  'h-[18px] w-[18px] border border-[#cadcf8] after:absolute after:left-[4.5px] after:top-0.5 after:h-[9px] after:w-[7px] after:rotate-45 after:border-0 after:border-b-2 after:border-r-2 after:border-solid after:border-[var(--color-surface)]';

const checkBoxMarkStandaloneClassName = 'checkmark absolute left-0 top-0';

const checkBoxMarkRoundedClassName = 'rounded-full';

const checkBoxMarkSquareClassName = 'rounded-[5px]';

const checkBoxMarkUncheckedEnabledClassName =
  'bg-[var(--color-surface)] after:hidden group-hover:bg-[var(--color-accent)]';

const checkBoxMarkCheckedEnabledClassName =
  'bg-[var(--color-text-muted)] after:block group-hover:bg-[var(--color-text-muted)]';

const checkBoxMarkUncheckedDisabledClassName = 'bg-[var(--color-border)] after:hidden';

const checkBoxMarkCheckedDisabledClassName =
  'bg-[var(--color-form-field-disabled-icon,var(--color-text-muted))] after:block';

type TParams = {
  checked: boolean;
  disabled: boolean;
  rounded?: boolean;
  hasLabel: boolean;
};

export const getCheckBoxMarkClassName = ({ checked, disabled, rounded, hasLabel }: TParams) => {
  const stateClassName = disabled
    ? checked
      ? checkBoxMarkCheckedDisabledClassName
      : checkBoxMarkUncheckedDisabledClassName
    : checked
      ? checkBoxMarkCheckedEnabledClassName
      : checkBoxMarkUncheckedEnabledClassName;

  return [
    checkBoxMarkShapeClassName,
    rounded ? checkBoxMarkRoundedClassName : checkBoxMarkSquareClassName,
    hasLabel ? 'relative' : checkBoxMarkStandaloneClassName,
    stateClassName,
  ]
    .filter(Boolean)
    .join(' ');
};
